export const COOKIE_KEYS = {
  CAST_AI_WEB_COOKIE: '_cast_redirect_context',
};
